// File: src/data/brandsModels.js
export const BRANDS_MODELS = {
  "Maruti Suzuki": [
    "Alto", "Alto K10", "S-Presso", "Wagon R", "Celerio", "Swift",
    "Dzire", "Baleno", "Ignis", "Fronx", "Brezza", "Ertiga",
    "XL6", "Ciaz", "Jimny", "Grand Vitara", "Invicto"
  ],
  "Hyundai": [
    "Exter", "Grand i10 Nios", "i20", "i20 N Line", "Aura",
    "Venue", "Venue N Line", "Verna", "Creta", "Creta N Line",
    "Alcazar", "Tucson", "Ioniq 5", "Kona Electric"
  ],
  "Tata Motors": [
    "Tiago", "Tiago NRG", "Tigor", "Tigor EV", "Altroz",
    "Punch", "Nexon", "Nexon EV", "Harrier", "Safari",
    "Curvv", "Curvv EV"
  ],
  "Mahindra": [
    "XUV 3XO", "Bolero", "Bolero Neo", "Thar", "Thar Roxx",
    "Scorpio", "Scorpio N", "Scorpio Classic", "XUV400",
    "XUV700", "Marazzo", "Alturas G4", "XUV300"
  ],
  "Kia": [
    "Sonet", "Seltos", "Carens", "EV6", "Carnival", "Syros"
  ],
  "Honda": [
    "Amaze", "City", "City Hybrid", "Elevate", "CR-V"
  ],
  "Toyota": [
    "Glanza", "Urban Cruiser Taisor", "Rumion", "Innova Crysta",
    "Innova Hycross", "Fortuner", "Hilux", "Land Cruiser",
    "Camry", "Vellfire"
  ],
  "Skoda": [
    "Kushaq", "Slavia", "Kodiaq", "Superb", "Octavia"
  ],
  "Volkswagen": [
    "Taigun", "Virtus", "Tiguan"
  ],
  "Renault": [
    "Kwid", "Triber", "Kiger"
  ],
  "Nissan": [
    "Magnite", "X-Trail"
  ],
  "MG Motor": [
    "Comet EV", "ZS EV", "Astor", "Hector", "Hector Plus",
    "Gloster", "Windsor EV"
  ],
  "Citroen": [
    "C3", "C3 Aircross", "eC3", "C5 Aircross", "Basalt"
  ],
  "Jeep": [
    "Compass", "Meridian", "Wrangler"
  ],
  "Ford": [
    "Endeavour", "Mustang"
  ],
  "BMW": [
    "2 Series Gran Coupe", "3 Series", "5 Series", "7 Series",
    "X1", "X3", "X4", "X5", "X6", "X7", "Z4", "i4", "i5", "iX", "iX1"
  ],
  "Mercedes-Benz": [
    "A-Class Limousine", "C-Class", "E-Class", "S-Class",
    "GLA", "GLB", "GLC", "GLE", "GLS", "EQB", "EQE", "EQS",
    "AMG GT", "G-Class"
  ],
  "Audi": [
    "A4", "A6", "A8", "Q3", "Q5", "Q7", "Q8", "e-tron",
    "e-tron GT", "RS Q8"
  ],
  "Volvo": [
    "XC40", "XC40 Recharge", "XC60", "XC90", "S90", "C40 Recharge"
  ],
  "Lexus": [
    "ES", "NX", "RX", "LX", "LC"
  ],
  "Jaguar": [
    "XE", "XF", "F-Pace", "E-Pace", "I-Pace"
  ],
  "Land Rover": [
    "Range Rover Evoque", "Range Rover Velar", "Range Rover Sport",
    "Range Rover", "Discovery Sport", "Defender"
  ],
  "Porsche": [
    "718", "911", "Taycan", "Panamera", "Macan", "Cayenne"
  ],
  "Maserati": [
    "Ghibli", "Levante", "Quattroporte", "MC20", "Grecale"
  ],
  "Lamborghini": [
    "Huracan", "Urus", "Revuelto"
  ],
  "Ferrari": [
    "Roma", "Portofino", "F8 Tributo", "SF90 Stradale", "812 GTS", "Purosangue"
  ],
  "Rolls-Royce": [
    "Ghost", "Phantom", "Cullinan", "Spectre"
  ],
  "Bentley": [
    "Continental GT", "Flying Spur", "Bentayga"
  ],
  "Aston Martin": [
    "DB11", "DB12", "DBX", "Vantage"
  ],
  "BYD": [
    "Atto 3", "e6", "Seal"
  ],
  "Tesla": [
    "Model 3", "Model Y"
  ],
  "Mini": [
    "Cooper 3 Door", "Cooper 5 Door", "Cooper S", "Countryman", "Cooper SE"
  ],
  "Force Motors": [
    "Gurkha", "Urbania", "Trax"
  ],
  "Isuzu": [
    "D-Max", "V-Cross", "MU-X"
  ]
};

export const BRAND_LOGO_MAP = {
  "Maruti Suzuki": "MS", "Hyundai": "HY", "Tata Motors": "TA",
  "Mahindra": "MA", "Honda": "HO", "Toyota": "TO", "Kia": "KI",
  "MG Motor": "MG", "Renault": "RE", "Nissan": "NI", "Volkswagen": "VW",
  "Skoda": "SK", "Ford": "FO", "Jeep": "JP", "Citroen": "CI",
  "BYD": "BY", "Mercedes-Benz": "MB", "BMW": "BM", "Audi": "AU",
  "Lexus": "LX", "Volvo": "VO", "Jaguar": "JA", "Land Rover": "LR",
  "Porsche": "PO", "Maserati": "MT", "Lamborghini": "LB", "Ferrari": "FR",
  "Rolls-Royce": "RR", "Bentley": "BE", "Aston Martin": "AM", "Tesla": "TE",
  "Mini": "MI", "Force Motors": "FM", "Isuzu": "IZ",
};

export const POPULAR_BRANDS = [
  "Maruti Suzuki", "Hyundai", "Tata Motors", "Mahindra",
  "Honda", "Toyota", "Kia", "MG Motor", "Renault", "Nissan",
  "Volkswagen", "Skoda"
];

export const getAllBrands = () => Object.keys(BRANDS_MODELS);
export const getModelsByBrand = (brand) => BRANDS_MODELS[brand] || [];
export const getBrandLogo = (name) =>
  BRAND_LOGO_MAP[name] || name.slice(0, 2).toUpperCase();